import { authPageContainerClass } from "@/layout/auth-layout.styles";
import { Typography } from "@iluvatar/ui-kit";
// libraries
import { optionalSearchString } from "@/utilities/search-params";
import { createFileRoute, useSearch } from "@tanstack/react-router";

// components
import UnAuthLayout from "../layout/unauthed-page";

// styles

// types & constants
import { Icon } from "@/components/Icon";

function AboutPage(): JSX.Element {
  const search = useSearch({ strict: false });
  return (
    <UnAuthLayout>
      <div
        className={`${authPageContainerClass} max-w-[450px] w-full mx-auto px-2`}
      >
        <div className="w-[170px] justify-center align-center mt-[24px]">
          <Icon />
        </div>
        <Typography
          variant="h5"
          className="[color:rgb(var(--uik-subtle))] [margin-top:8px] [margin-bottom:24px]"
        >
          {search.intro ? search.intro : "Welcome to Bubble!"}
        </Typography>

        <Typography
          className={["mb-4", "[color:rgb(var(--uik-info))]"]
            .filter(Boolean)
            .join(" ")}
        >
          Our intentions are to create a place for people to connect with
          life-minded folk. This app was built with the Covid Conscious person
          in mind. If thats not you, you should wear a mask, then join. In the
          future, I hope to extend into many different types / sub-types of
          communities, letting you create multiple profiles for all of your
          varying interests.
        </Typography>

        <Typography
          className={["mb-4", "[color:rgb(var(--uik-info))]"]
            .filter(Boolean)
            .join(" ")}
        >
          The site is pretty simple, create profiles that describes you, your
          interests, and what your looking for; then, take a look at who's out
          there. Like and Match with others, Chat, and make connections.
        </Typography>

        <Typography
          className={["mb-4", "[color:rgb(var(--uik-info))]"]
            .filter(Boolean)
            .join(" ")}
        >
          Our community is varied and diverse. You will run into people you do
          not get along with. Please respect other peoples opinions. No name
          calling. Play nice.
        </Typography>

        <Typography
          className={["mb-4", "[color:rgb(var(--uik-info))]"]
            .filter(Boolean)
            .join(" ")}
        >
          With that said, if you encounter any harassment, please report it
          using the report user button under the user profile. You will be able
          to upload any sort of proof of the interactions that seem relevant
          (screenshots / exc).
        </Typography>

        <Typography
          className={["mb-4", "[color:rgb(var(--uik-info))]"]
            .filter(Boolean)
            .join(" ")}
        >
          There will be a place for general feedback and feature requests, but
          that a future problem. For now, carrier pigeons.
        </Typography>
      </div>
    </UnAuthLayout>
  );
}

export const Route = createFileRoute("/about")({
  component: AboutPage,
  validateSearch: optionalSearchString("intro"),
});
